module.exports = __webpack_public_path__ + "media/steps/dowod_rejestracyjny_bcg@2x-ed7d535c.png";